// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Auth } from 'aws-amplify';
import { Form, Formik } from 'formik';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { isValidPassword } from '../../../lib/validation';
import PasswordInput from '../../../components/PasswordInput';
import S from './styles';
import { getQueryParams, useQuery } from '../../../lib/utility';
import { FormattedMessage, useIntl } from 'react-intl';

const ResetPasswordForm = (): JSX.Element => {
  const { username, code } = getQueryParams(useQuery());
  const history = useHistory();
  const intl = useIntl();
  return (
    <Formik
      initialValues={{ password: '' }}
      validate={({ password }) => {
        const errors: { password?: string } = {};
        if (!password) {
          errors.password = `*${intl.formatMessage({ id: 'J054' })}`;
        } else if (!isValidPassword(password)) {
          errors.password = `*${intl.formatMessage({ id: 'J054' })}`;
        }
        return errors;
      }}
      onSubmit={({ password }) => {
        console.log({ username, code, password });
        Auth.forgotPasswordSubmit(username, code, password)
          .then(data => {
            console.log({ data });
            history.push('/resetPassword?reset=success');
          })
          .catch(err => {
            console.log({ err });
            history.push('/resetPassword?reset=failed');
          })
      }}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        isSubmitting
      }) => (
        <S.Container as={Form}>
          <S.TopWrapper>
            <S.PasswordWrapper>
              <PasswordInput
                name="password"
                label={intl.formatMessage({ id: 'J053' })}
                placeholder={intl.formatMessage({ id: 'J053' })}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                error={errors.password}
                touched={touched.password}
                autoComplete="new-password" />
              {!values.password && !touched.password && <S.NotePasswordRule>{intl.formatMessage({ id: 'J056' })}</S.NotePasswordRule>}
            </S.PasswordWrapper>
          </S.TopWrapper>
          <S.BottomWrapper>
            <S.Button
              type="submit"
              disabled={isSubmitting || Object.keys(errors).length > 0}
            >{intl.formatMessage({ id: 'J055' })}</S.Button>
          </S.BottomWrapper>
        </S.Container>
      )}
    </Formik>
  );
}

export { ResetPasswordForm as default }
